import React, { useContext } from "react"
import { Carousel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { EditorInfoContext } from "../../../../../../../utils/userInfoContext";
import CustomTooltip from "../../../../../../Elements/Tooltip";
import CookieBlockedMessage from "../../../../../../CommonComponents/CookieBlockedMessage";
import { useAcceptAll } from "../../../../../../../hooks/useCookieChoiceMade";
import { isExternalUrl } from "../../../../../../../utils/cookieConsentUtils";

const ImageSlider = ({ arrayOfImageElements, showIcons, dimensions }) => {
    const { setEditElement, setOpenRemoveModal, setOpenAddElement, setToolType } = useContext(EditorInfoContext)
    // Editor's own thumbnail-picker list (showIcons=true) stays a fixed compact size regardless
    // of the lightbox's configured dimensions; the real viewer (showIcons=false) passes the
    // lightbox's own width/height so every slide respects the one shared size control.
    const slideWidth = dimensions?.width || 200;
    const slideHeight = dimensions?.height || 200;
    const acceptAll = useAcceptAll();
    return (
        <div className="custom-carousel">
            <Carousel
                nextIcon={<span className="carousel-control-next-icon custom-icon" />}
                prevIcon={<span className="carousel-control-prev-icon custom-icon" />}
            >
                {arrayOfImageElements?.map((image, index) => (
                    image?.element_type_name === 'Image' && (image?.file_url !== undefined || image?.value?.gif_link !== undefined) &&
                    <Carousel.Item key={index} className="carousel-item-container">
                        {showIcons ? <div className="image-label">{index + 1}</div> : <></>}
                        {!image?.file_url && isExternalUrl(image?.value?.gif_link) && !acceptAll ? (
                            <CookieBlockedMessage contentType="image" sourceUrl={image?.value?.gif_link} style={{ width: slideWidth, height: slideHeight }} />
                        ) : <img className="d-block"
                            src={image?.file_url ?? image?.value?.gif_link}
                            alt={`Slide ${index + 1}`}
                            style={{
                                width: slideWidth,
                                height: slideHeight,
                                maxWidth: showIcons ? undefined : '95vw',
                                maxHeight: showIcons ? undefined : '90vh',
                                objectFit: 'contain'
                            }}
                        />}
                        {showIcons ? <div className="slider-action-icons">
                            <CustomTooltip title={<p className="p-1 text-light">Remove image</p>}>
                                <button
                                    className="slider-icon-btn slider-icon-btn--remove"
                                    onClick={() => {
                                        setEditElement(image);
                                        setOpenRemoveModal(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTrashCan} />
                                </button>
                            </CustomTooltip>
                            <CustomTooltip title={<p className="p-1 text-light">Edit image</p>}>
                                <button
                                    className="slider-icon-btn slider-icon-btn--edit"
                                    onClick={() => {
                                        setToolType('LightboxesToolbox')
                                        setEditElement(image);
                                        setOpenAddElement(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPencil} />
                                </button>
                            </CustomTooltip>
                        </div> : <></>
                        }
                    </Carousel.Item>
                ))}
            </Carousel>
            {showIcons ? <div className="total-images">Total images: {arrayOfImageElements?.length}</div> : <></>}
        </div>
    )
}
export default ImageSlider
